import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Compétence } from '../../croisement-référentiel/models/compétences';
import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { avecMéthodesCompétence } from './compétences.methods';

export const CompétenceStore = signalStore(
  { providedIn: 'root' },
  withEntities<Compétence>(),
  withSelectedEntity(),
  avecMéthodesCompétence(),
);
